import React, { useState } from "react";
import { TextField, Button, Typography, Alert, Paper, Box } from "@mui/material";

const RegistrationForm = ({ onRegisterSuccess, onSwitchToLogin }) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleRegister = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, email, password }),
      });
  
      const contentType = response.headers.get("Content-Type") || "";
  
      if (!response.ok) {
        if (contentType.includes("application/json")) {
          const data = await response.json();
          throw new Error(data.message || "Registration failed");
        } else {
          throw new Error("Server returned an unexpected response");
        }
      }
  
      setSuccess(true);
      setError(null);
      onRegisterSuccess();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Paper style={{ padding: "24px", width: "100%", maxWidth: "400px" }}>
      <Typography
        variant="h5"
        gutterBottom
        style={{ textAlign: "center", marginBottom: "16px" }}
      >
        Register
      </Typography>
      {error && (
        <Alert severity="error" style={{ marginBottom: "16px" }}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" style={{ marginBottom: "16px" }}>
          Registration successful! You can now log in.
        </Alert>
      )}
      <TextField
        label="Username"
        variant="outlined"
        fullWidth
        margin="normal"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <TextField
        label="Email"
        variant="outlined"
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        label="Password"
        variant="outlined"
        type="password"
        fullWidth
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button
        variant="contained"
        fullWidth
        onClick={handleRegister}
        style={{ marginTop: "16px", backgroundColor: "#3f51b5", color: "#fff" }}
      >
        Register
      </Button>
      <Box mt={2} textAlign="center">
        <Button variant="text" onClick={onSwitchToLogin}>
          Already have an account? Login
        </Button>
      </Box>
    </Paper>
  );
};

export default RegistrationForm;
